import { useEffect, useState } from 'react';
import NavCard from '../components/NavCard';
import ProjectHelpfulTipsContainer from '../components/builder/ProjectHelpfulTipsContainer';
import useBrowserStorageState from '../hooks/useBrowserStorageState';
import { MdPeople } from 'react-icons/md';
import { FaRegAddressBook, FaRegLightbulb } from 'react-icons/fa';
import { TbChartCandle } from 'react-icons/tb';
import { MdBolt } from 'react-icons/md';

export default function DashboardIndex() {
  const [shownPlatformDemoTipCount, setShownPlatformDemoTipCount] =
    useBrowserStorageState('localStorage', 'shownPlatformDemoTipCount', 0);

  const [showTip, setShowTip] = useState(false);

  // TODO: Removed this for AIQ instance
  // useEffect(() => {
  //   if (shownPlatformDemoTipCount < 3) {
  //     setShowTip(true);
  //   }
  // }, [setShownPlatformDemoTipCount, shownPlatformDemoTipCount]);
  
  // Helpful tips disabled by default
  useEffect(() => {
    setShowTip(false);
  }, []);

  return (
    <div className="relative w-full h-full overflow-auto">
      <div className="w-full h-full flex flex-grow-0 justify-center items-center pb-40 pt-36 px-7 space-x-7">
        <NavCard
          label="Audiences"
          description="Create your perfect audience for marketing outreach across channels."
          to="audiences/audiencebuilder"
          icon={<MdPeople />}
        />
        <NavCard
          label="Activations"
          description="Distribute your audiences for targeting across key media platforms."
          to="activations/activationbuilder"
          icon={<MdBolt />}
        />
        <NavCard
          label="Enhancements"
          description="Maximize the power of your current file with additional data points appended to your records."
          to="enhancements"
          icon={<FaRegAddressBook />}
        />
        <NavCard
          label="Insights"
          description="Learn more about your existing customers and prospects with profile reports."
          to="insights"
          icon={<TbChartCandle />}
        />
        <NavCard
          label="Ask Addy"
          description="Select a profile report and let Addy turn it into insights you can refine in chat."
          to="ask-addy"
          icon={<FaRegLightbulb />}
        />
      </div>
      <ProjectHelpfulTipsContainer
        show={showTip}
        incrementShownCount={() =>
          setShownPlatformDemoTipCount((prev) => (prev += 1))
        }
      />
    </div>
  );
}
